import { Stack, Typography } from '@mui/material';
import type { Condition } from '@repo/api-gw-sdk';
import { useState } from 'react';

import ConfirmationDialog from '@/components/dialogs/confirmationDialog';
import OptionMenu from '@/components/option-menu/option-menu';
import { useRoles } from '@/contexts/useRoles';

export const RansomwareByConditionViewerHeader = ({
  onSave,
  onEdit,
}: {
  onSave: (
    condition?: Condition,
    include?: string[],
    exclude?: string[]
  ) => Promise<void>;
  onEdit: (event: React.MouseEvent<HTMLElement>) => void;
}) => {
  const { isAuthorized } = useRoles();
  const [clearDialogIsOpen, setClearDialogIsOpen] = useState(false);

  const onClearMenuItemClick = (event: React.MouseEvent<HTMLElement>) => {
    event.stopPropagation();
    setClearDialogIsOpen(true);
  };

  const onConfirmClick = async () => {
    await onSave();
    setClearDialogIsOpen(false);
  };

  return (
    <>
      <Stack
        width='100%'
        direction='row'
        alignItems='center'
        justifyContent='space-between'
      >
        <Typography variant='h4'>Resource selection</Typography>
        <OptionMenu
          options={[
            {
              id: 'edit-policy',
              text: 'Edit',
              menuItemProps: {
                disabled: !isAuthorized('update:security_plan'),
                onClick: onEdit,
              },
            },
            {
              id: 'clear-all-policies',
              text: 'Clear all',
              menuItemProps: {
                disabled: !isAuthorized('update:security_plan'),
                onClick: onClearMenuItemClick,
              },
            },
          ]}
        />
      </Stack>
      <ConfirmationDialog
        isOpen={clearDialogIsOpen}
        title='Clear all resources assignment'
        description='Removing this condition stops ransomware detection on matching resources.'
        onCancel={() => setClearDialogIsOpen(false)}
        onConfirm={onConfirmClick}
        confirmSnackbarText='Ransomware condition was cleared'
        buttonTitle='Clear all'
      />
    </>
  );
};
